//个人信息
import React, { useCallback, useState } from "react"
import { observer } from "mobx-react-lite"
import styled from '~/ui/styled'
import { useStores } from "~models"
import useNavigation from "~hooks/useNavigation"
import QrCodeCard from "~components/qrcode-card"
import Item from "./components/item"
import Icon from "~widgets/icon"
import { Avatar } from "~widgets/avatar"
import Modal from "./components/modal"
import { UserGender } from "~proto"
import { usePopup } from "~hooks/usePopup"
// import { globalToast } from "~utils"
import UpdateCurrentUserDisplayName from "./components/update-current-user-display-name"
import UpdateCurrentUserDisplayDesc from "./components/update-current-user-display-desc"
import UpdateCurrentUserUserName from "./components/update-current-user-display-id"
import { ColumnFlex } from "~components/El"

const genderText = {
  [UserGender.MALE]: "男",
  [UserGender.FEMALE]: "女",
}

enum ItemType {
  AVATAR = "avatar", // 头像
  NICKNAME = "nickname", // 昵称
  ACCOUNTS = "accounts", // 帐号
  EMAIL = "email", // 电子邮箱
  QRCODE = "qrCode", // 我的二维码
  SEX = "sex", // 性别
  DISPLAY_DESC = "displayDesc", // 个性签名
}

const Container = styled(ColumnFlex)`
  padding: 16px;
  height: auto;
`

const BasicInfo: React.FC = () => {
  const popup = usePopup()
  const [visible, setVisible] = useState(false)
  const {
    userStore: { currentUser },
  } = useStores()

  if (!currentUser) {
    return null
  }
  const navigation = useNavigation()

  const openQrcodeModal = useCallback(() => {
    popup.open({
      type: "center",
      width: "100%",
      content: React.createElement(QrCodeCard, { user: currentUser }),
    })
  }, [currentUser, popup])

  const openNicknameModal = useCallback(() => {
    const p = popup.open({
      type: "bottom",
      width: "100%",
      height: "100%",
      content: () => (
        <UpdateCurrentUserDisplayName
          onDismiss={() => {
            popup.close(p.id)
          }}
        />
      ),
    })
  }, [popup])

  const openDisplayDescModal = useCallback(() => {
    const p = popup.open({
      type: "bottom",
      width: "100%",
      height: "100%",
      content: () => <UpdateCurrentUserDisplayDesc onDismiss={() => {
        popup.close(p.id)
      }} />,
    })
  }, [popup])

  const openUserNameModal = useCallback(() => {
    const p = popup.open({
      type: "bottom",
      width: "100%",
      height: "100%",
      content: () => <UpdateCurrentUserUserName onDismiss={() => {
        popup.close(p.id)
      }} />,
    })
  }, [popup])
  const onPressFn = useCallback((type: any) => {
    const typeList = {
      [ItemType.AVATAR]: () => {
        navigation.navigate("Avatar")
      },
      [ItemType.NICKNAME]: () => {
        openNicknameModal()
      },
      [ItemType.DISPLAY_DESC]: () => {
        openDisplayDescModal()
      },
      [ItemType.ACCOUNTS]: () => {
        openUserNameModal()
      },

      [ItemType.EMAIL]: () => {
        navigation.navigate("UpdateCurrentUserEmail")
      },

      [ItemType.QRCODE]: () => {
        openQrcodeModal()
      },

      [ItemType.SEX]: () => {
        // navigation.push("UpdateCurrentUserGender")
        setVisible(true)
      },
    }
    typeList[type]()
  }, [currentUser, navigation, openNicknameModal, openQrcodeModal])

  return (
    <>
      <Container>
        <Item
          title="头像"
          onClick={() => onPressFn(ItemType.AVATAR)}
          icon={
            <Avatar
              size={36}
              avatar={currentUser.avatar}
              name={currentUser.name}
            />
          }
        />
        <Item title="昵称" value={currentUser.name} onClick={() => onPressFn(ItemType.NICKNAME)} />
        <Item title="个性签名" value={currentUser.desc} onClick={() => onPressFn(ItemType.DISPLAY_DESC)} />
        <Item title="账号" value={currentUser.username} onClick={() => onPressFn(ItemType.ACCOUNTS)} />
        {/* <Item
          title="电子邮箱"
          value={currentUser.email}
          onClick={() => onPressFn(ItemType.EMAIL)}
        /> */}
        <Item
          title="我的二维码"
          onClick={() => onPressFn(ItemType.QRCODE)}
          icon={<Icon name={"qrCode"} size={16} color={"#aaaaaa"} />}
        />
        <Item
          title="性别"
          type={ItemType.SEX}
          value={genderText[currentUser.gender]}
          onClick={() => onPressFn(ItemType.SEX)}
        />
      </Container>
      <Modal visible={visible} showVisible={() => setVisible(false)} />
    </>
  )
}

export default observer(BasicInfo)
